import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as sideBarActions from '../../../../redux/sideBarActions';
import * as fabricCanvasActions from '../../../../redux/fabricCanvasActions';
import { bindActionCreators } from 'redux';
import * as Constants from '../../../../utilities/constants/Constants';
import { Tooltip } from 'reactstrap';
import './MaterialDetails.scss';
import { string } from '../../../../localization';

class MaterialDetails extends Component {
  state = {
    nameTooltipOpen: false,
    priceTooltipOpen: false,
    // selectedMaterial: this.props.storeData.materials[this.props.materialIndex],
    selectedMaterial: null,
    materialNameIndex: 0,
    materialPriceIndex: 0,
    materialIndex: 0
  };

  onSelectMaterial = index => {
    const { storeData } = this.props;
    this.setState({ selectedMaterial: storeData.materials[index] });
    this.setState({ materialIndex: index });
  };

  componentDidMount = () => {
    this.onSelectMaterial(this.getMaterialIndex());
  };

  getMaterialIndex = () => {
    const { storeData, materialId, dispatchers } = this.props;
    let tempMaterialIndex = 0;
    if (materialId != null) {
      storeData.materials.forEach((element, index) => {
        if (element.id === materialId) {
          tempMaterialIndex = index;
          dispatchers.sideBarActions.setMaterial(index, element.id);
        }
      });
    } else {
      dispatchers.sideBarActions.setMaterial(0, storeData.materials[0].id);
    }
    return tempMaterialIndex;
  };

  mouseEnterName = index => {
    this.setState({
      nameTooltipOpen: true,
      materialNameIndex: index
    });
  };

  mouseLeaveName = () => {
    this.setState({
      nameTooltipOpen: false
    });
  };

  mouseEnterPrice = index => {
    this.setState({
      priceTooltipOpen: true,
      materialPriceIndex: index
    });
  };

  mouseLeavePrice = () => {
    this.setState({
      priceTooltipOpen: false
    });
  };

  showMaterialChoiceAppliedDialog = () => {
    const { dispatchers } = this.props;
    const dict = {
      header: '',
      description: string.MATERIAL_CHOICE_APPLIED,
      stringColor: Constants.DEFAULT_STRING_COLOR,
      onclick: null,
      buttonTitles: {
        finish: string.OK_KEY,
        cancel: ''
      }
    };
    dispatchers.fabricCanvasActions.setMessageDialogParams(dict);
  };

  handleApplyMaterial = () => {
    const { dispatchers } = this.props;
    const { materialIndex, selectedMaterial } = this.state;
    dispatchers.sideBarActions.setMaterial(materialIndex, selectedMaterial.id);
    dispatchers.fabricCanvasActions.makeProjectDirtyWithNoUndoSupport(true);
    this.showMaterialChoiceAppliedDialog();
  };

  materialPrice = (materials, index, unitSystem) => {
    if (unitSystem === Constants.METRIC_KEY) {
      return materials[index].pricePerSqm;
    }
    return materials[index].pricePerSqft;
  };

  setMaterialNameWidth = () => {
    const { storeData, enterpriseAccount } = this.props;
    if (!storeData.hidePricing) {
      if (enterpriseAccount) {
        return '74px';
      }
      return '154px';
    }
    if (enterpriseAccount) {
      return '154px';
    }
    return null;
  };

  render() {
    const { storeData, unitSystem, enterpriseAccount } = this.props;
    const {
      materialPriceIndex,
      materialNameIndex,
      selectedMaterial,
      nameTooltipOpen,
      priceTooltipOpen
    } = this.state;

    const currencyPlacement = storeData.placeMsrpCurrency;
    return (
      <div id='material-tab'>
        <div style={{ marginBottom: '10px' }}>
          <img
            style={{ width: '100%' }}
            alt='arrow-theme'
            src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARAAAAAKCAYAAAB8MAFcAAABTElEQVRoQ+2YvUrEUBCFz2TBBf+w28Y3sFAbG61F1kYbNz8+XCq3SCMEiSiuQXsrX0Fj52LUVQyORAhso6QQHLgndQJnvjl83BuB8ScMw42yLG/TNH01HpXxSMA5AmJ54oMo2vQUZ6J6U1Uf20mSTCznZTYScI2AWYEEQbAF8U4BzNVLUcX1y/PTDk8irlWU81omYFIg0/KoxSGCNQALUB11uzO7cRy/WYbKbCTgCgFzAqn/eXxCLgWYhep5Udz3e73lFa+jVwAWa4mMx4/9LMveXVkS5yQBqwRMCeRbHooLEZlv5JHneVXDGwwOVykRqzViLlcJmBHIb/JolkOJuFpTzm2VgAmBtJEHJWK1QszlMoF/F8i0PFRx8lDc7TXXlp8Ww5OIy5Xl7JYISBBGaiKQ6vFweLTfNovv++vidUYAltp+w/dIgAT+lsAXZKqrGHMlWUoAAAAASUVORK5CYII='
          />
        </div>
        <div className='detail-container'>
          {storeData.materials.map((item, index) => (
            <div key={item.id} className='sub-container'>
              <div className='d-flex'>
                {enterpriseAccount ? (
                  <div className='material-icon-container'>
                    {item.thumbnail !== '' ? (
                      <img src={item.thumbnail} alt='thumbnail' />
                    ) : null}
                  </div>
                ) : null}
                <div>
                  <button
                    type='button'
                    style={{
                      border: 'none',
                      background: 'none',
                      outline: 'none'
                    }}
                    className={`material-name-price ${
                      selectedMaterial !== null &&
                      selectedMaterial.id === item.id
                        ? 'selected-material '
                        : null
                    }`}
                    onClick={() => this.onSelectMaterial(index)}
                  >
                    <div
                      id={`tooltip${item.id}`}
                      style={{
                        maxWidth: this.setMaterialNameWidth()
                      }}
                      className='material-name'
                      onMouseEnter={() => this.mouseEnterName(index)}
                      onMouseLeave={() => this.mouseLeaveName()}
                    >
                      {item.name}({item.finishing})
                    </div>

                    {!storeData.hidePricing ? (
                      <div
                        id={`tooltip-price${item.id}`}
                        className={`price ${
                          currencyPlacement === Constants.BEFORE_PRICE_KEY
                            ? ' before-price'
                            : null
                        }`}
                        onMouseEnter={() => this.mouseEnterPrice(index)}
                        onMouseLeave={() => this.mouseLeavePrice()}
                      >
                        <div>
                          {this.materialPrice(
                            storeData.materials,
                            index,
                            unitSystem
                          )}
                          {/* {' '}
                          {unit_system === Constants.IMPERIAL_KEY
                            ? item.pricePerSqft
                            : item.pricePerSqm} */}
                        </div>
                        <div> {storeData.msrpCurrency}</div>
                      </div>
                    ) : null}
                  </button>
                  <div
                    className='description'
                    style={{ width: enterpriseAccount ? '190px' : '265px' }}
                  >
                    {item.description}
                  </div>
                </div>
              </div>

              <hr />
            </div>
          ))}
          <Tooltip
            id='tooltip-inner'
            placement='top'
            isOpen={nameTooltipOpen}
            target={`tooltip${storeData.materials[materialNameIndex].id}`}
          >
            {storeData.materials[materialNameIndex].name}(
            {storeData.materials[materialNameIndex].finishing})
          </Tooltip>
          {!storeData.hidePricing ? (
            <Tooltip
              id='tooltip-inner'
              placement='top'
              isOpen={priceTooltipOpen}
              target={`tooltip-price${storeData.materials[materialPriceIndex].id}`}
            >
              <div
                className={`d-flex ${
                  currencyPlacement === Constants.BEFORE_PRICE_KEY
                    ? 'd-flex flex-row-reverse'
                    : null
                }`}
              >
                <div>
                  {' '}
                  {this.materialPrice(
                    storeData.materials,
                    materialPriceIndex,
                    unitSystem
                  )}
                  {/* {unit_system === Constants.IMPERIAL_KEY
                  ? storeData.materials[materialPriceIndex]
                      .pricePerSqft
                  : storeData.materials[materialPriceIndex]
                      .pricePerSqm} */}
                </div>
                <div> {storeData.msrpCurrency}</div>
              </div>
            </Tooltip>
          ) : null}
        </div>
        <div className='button'>
          <button type='button' onClick={this.handleApplyMaterial}>
            {string.APPLY_KEY}
          </button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    storeData: state.modal.storeData,
    enterpriseAccount: state.modal.envData.enterprise_account,
    unitSystem: state.home.unitSystem,
    materialId: state.finalCheck.project.materialId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MaterialDetails);
